import firewall from './Firewall';
import {createLogger} from 'redux-logger';
import promise from 'redux-promise';
import thunk from 'redux-thunk';

const logger = createLogger();

export default [
    thunk,
    promise,
    firewall,
    logger
]



// WEBPACK FOOTER //
// ./src/redux/middlewares/index.js